import { render, staticRenderFns } from "./MarketLastOrderModal.vue?vue&type=template&id=da003150&"
import script from "./MarketLastOrderModal.vue?vue&type=script&lang=js&"
export * from "./MarketLastOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports